module.exports = __webpack_public_path__ + "img/line.8184798b.svg";